/**
 * Copyright © 2024-2026 Entangled Harmony Labs, LLC
 * All Rights Reserved. Proprietary and Confidential.
 */
import React from 'react';
import { Sparkles, X } from 'lucide-react';
import { SignUpButton } from '@clerk/clerk-react';

interface AnonymousBannerProps {
  onDismiss?: () => void;
}

const AnonymousBanner: React.FC<AnonymousBannerProps> = ({ onDismiss }) => {
  return (
    <div className="bg-gradient-to-r from-green-600 to-teal-600 text-white px-4 py-3 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1">
          <Sparkles className="h-5 w-5 flex-shrink-0" />
          <div className="flex-1">
            <p className="font-semibold text-sm">
              🎸 Try Guituitive
            </p>
            <p className="text-xs text-green-100">
              Viewing C major • Sign up free for Major, Minor & Pentatonic scales + Harmonic Companion chat (5 chats per month on free tier, ulimited for pro)
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <SignUpButton mode="modal">
            <button
              className="flex items-center gap-1 px-4 py-2 bg-white text-green-700 hover:bg-green-50 rounded-lg text-sm font-semibold transition-colors shadow-sm"
            >
              Sign Up Free
            </button>
          </SignUpButton>

          {onDismiss && (
            <button
              onClick={onDismiss}
              className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
              aria-label="Dismiss banner"
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnonymousBanner;
